export const SETTINGS_TAB_OPTIONS = [
  { value: 'profile', label: 'Profilo' },
  { value: 'security', label: 'Sicurezza' },
  { value: 'switch-user', label: 'Cambio Utente' },
];

export function getInitialProfileForm(currentUser) {
  if (!currentUser) {
    return {
      fullName: '',
      email: '',
      phone: '',
      professionalTitle: '',
      staffType: 'interno',
      skills: '',
    };
  }

  return {
    fullName: currentUser.name || '',
    email: currentUser.email || '',
    phone: '',
    professionalTitle: '',
    staffType: 'interno',
    skills: '',
  };
}

export function getInitialSecurityForm() {
  return {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    showCurrentPassword: false,
    showNewPassword: false,
    showConfirmPassword: false,
    newEmail: '',
    newPhone: '',
  };
}
